// Lightweight effects: confetti + WebAudio "pop" sound. Browser-only, safe on SSR.
import confetti from "canvas-confetti";

let audioCtx = null;
function getCtx() {
  if (typeof window === "undefined") return null;
  if (audioCtx) return audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (Ctx) audioCtx = new Ctx();
  } catch {}
  return audioCtx;
}

export function playPop(checked) {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  // bright check tone (rising) when checking; lower tone when unchecking
  osc.frequency.setValueAtTime(checked ? 660 : 320, ctx.currentTime);
  osc.frequency.exponentialRampToValueAtTime(
    checked ? 880 : 220,
    ctx.currentTime + 0.08
  );
  gain.gain.setValueAtTime(0.0001, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.18);
  osc.type = "sine";
  osc.start();
  osc.stop(ctx.currentTime + 0.2);
}

// Descending water-drop / glug sound for adding a glass
export function playDrop() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();

  const t = ctx.currentTime;

  // First drop — descending pitch
  const osc1 = ctx.createOscillator();
  const gain1 = ctx.createGain();
  osc1.connect(gain1); gain1.connect(ctx.destination);
  osc1.type = "sine";
  osc1.frequency.setValueAtTime(540, t);
  osc1.frequency.exponentialRampToValueAtTime(200, t + 0.14);
  gain1.gain.setValueAtTime(0.0001, t);
  gain1.gain.exponentialRampToValueAtTime(0.14, t + 0.01);
  gain1.gain.exponentialRampToValueAtTime(0.0001, t + 0.18);
  osc1.start(t); osc1.stop(t + 0.2);

  // Second tiny ripple — slightly delayed, higher pitch
  const osc2 = ctx.createOscillator();
  const gain2 = ctx.createGain();
  osc2.connect(gain2); gain2.connect(ctx.destination);
  osc2.type = "sine";
  osc2.frequency.setValueAtTime(760, t + 0.1);
  osc2.frequency.exponentialRampToValueAtTime(380, t + 0.22);
  gain2.gain.setValueAtTime(0.0001, t + 0.1);
  gain2.gain.exponentialRampToValueAtTime(0.07, t + 0.11);
  gain2.gain.exponentialRampToValueAtTime(0.0001, t + 0.24);
  osc2.start(t + 0.1); osc2.stop(t + 0.26);
}

export function celebrate(kind = "default") {
  const palettes = {
    default: ["#4A6B53", "#7BA384", "#CDE0D1", "#FADBD8", "#E6B97A"],
    water: ["#A8D5EC", "#5C9DBF", "#7BB9D9", "#CDE7F2", "#4A6B53"],
    plant: ["#4A6B53", "#7BA384", "#5C8D6D", "#FADBD8", "#CC7A6B"],
  };
  const colors = palettes[kind] || palettes.default;
  const end = Date.now() + 900;
  (function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 70,
      origin: { x: 0, y: 0.85 },
      colors,
      scalar: 0.9,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 70,
      origin: { x: 1, y: 0.85 },
      colors,
      scalar: 0.9,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
  // Big burst at the top
  confetti({
    particleCount: 60,
    spread: 100,
    origin: { y: 0.4 },
    colors,
    scalar: 1.1,
  });
}
